<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="block__header">
        <h6 class="block__title">Header</h6>
        <a-tooltip slot="suffix" title="This is the top part of the app, which includes the banner, buttons for the banner, and the background for the back banner">
          <a-icon type="info-circle" class="text-primary" />
        </a-tooltip>
      </div>
      <a-button type="primary" @click="openEditModal">
        <a-icon type="edit" />
        Edit
      </a-button>
    </div>

    <div class="header-preview">
      <EmptyImage v-if="!selectedHeaderPreview?.image?.url" style="height: 144px;" />
      <div class="header-preview__container" v-else>
        <img :src="selectedHeaderPreview.image.url" alt="Header cover" />
        <ul class="header-preview__list">
          <li
            v-for="(button, idx) in selectedHeaderPreview.buttons"
            :key="idx"
            class="header-preview__button-container"
          >
            <div
              :title="button.deeplink"
              class="header-preview__button"
            >
              {{ button.title }}
            </div>
          </li>
        </ul>
      </div>
    </div>

    <HeaderEditModal
      v-if="isHeaderEditModalOpen"
      v-model="isHeaderEditModalOpen"
      :data="header"
      :initLang="selectedLanguage"
      @close="closeEditModal"
      @submit="handleModalSubmit"
    />
  </div>
</template>
<script>
import EmptyImage from '@/components/custom/emptyImage.vue'
import HeaderEditModal from '@/views/apps/custom-pages/constructor/content/modals/headerEditModal.vue'

import { mapGetters, mapActions, mapState } from 'vuex'

export default {
  components: {
    EmptyImage,
    HeaderEditModal,
  },
  computed: {
    ...mapGetters('content', ['header', 'isHeaderEditModalOpen', 'selectedLanguage']),
    ...mapState({
      langs: (state) => state.langs.langData,
    }),
    selectedHeaderPreview() {
      return this.header[this.selectedLanguage] ?? this.header.ru
    },
  },
  methods: {
    ...mapActions('content', ['updateHeader', 'setHeaderEditModalVisible']),
    openEditModal() {
      this.setHeaderEditModalVisible(true)
    },
    closeEditModal() {
      this.setHeaderEditModalVisible(false)
    },
    handleModalSubmit(data) {
      this.updateHeader(data)
    },
  },
}
</script>
<style lang="scss" scoped>
.header-preview {
  position: relative;
  margin-top: 12px;

  &__container {
    position: relative;
    display: flex;
    width: fit-content;
  }

  img {
    border-radius: 2px;
    height: 177px;
    max-width: 100%;
  }

  &__list {
    position: absolute;
    left: 0;
    padding: 0 16px;
    bottom: 12px;
    list-style: none;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: 8px;
    margin: 0;
    max-width: 100%;
    overflow-x: auto;
    scrollbar-width: thin;
  }

  &__button-container {
    flex: 0 0 auto;
  }

  &__button {
    border-radius: 8px;
    padding: 8px 12px;
    background-color: #ffffff33;
    color: #fff;
    text-decoration: none;
  }
}
</style>
